import { PaginationOutput } from "@core/store/types/PaginationOutput";
import { OfferWebmasterAvailable } from "@core/store/types/admin/offer/WebmastersAvailable";

export const availableWebmastersMapper = ({ items, count }: PaginationOutput<OfferWebmasterAvailable[]>): { items: OfferWebmasterAvailable[], count: number } => {
  return {
    items: items?.map(({ maximalAllowedRate, webmaster }) => ({ maximalAllowedRate, ...webmaster })) || [],
    count: count || 0
  };
};